<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{$t('visitorPorsant')}}</strong>
                            </CCol>


                        </CRow><CRow>
                            <CCol col="3">
                                <date-picker
                                         label="تاریخ شروع"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                        </CRow>

                    </CCardHeader>
                    <CCardBody>
                        {{$t('components.sumUserCommission')}}
                        <p>{{user_all_porsant}} {{ VUE_APP_Currency }}</p>

                        <CDataTable
                                :items="items_sell"
                                :fields="fields"
                                :items-per-page="20"
                                hover
                                sorter
                                :sorter-value="{column:'recId',asc:false}"
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <p >{{item.row_id+1}}</p>

                                </td>

                            </template>
                            <template #createdAt="{item}">

                                <td>
                                    <p >{{item.createdAt}}</p>

                                </td>

                            </template>


                            <template #soodFactorFromProuct="{item}">

                                <td>
                                    <p >{{parseInt(item.soodFactorFromProuct).toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")}}</p>

                                </td>


                            </template>

                            <template #userPorsant="{item}">

                                <td>
                                    <p >{{parseInt(item.userPorsant).toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")}}</p>

                                </td>


                            </template>
                            <template #customer="{item}">

                                <td>
                                    <p >{{item.partyName}}</p>

                                </td>

                            </template>

                            <template #user="{item}">

                                <td>
                                    <p >{{item.personName}}</p>

                                </td>

                            </template>


                            <template #operation="{item,index}">
                                <td >

                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.show')"
                                            size="sm"
                                            @click="goShowDocument(item,index)"
                                    ><CIcon name="cil-speedometer"/>
                                    </CButton>
                                </td>
                            </template>

                        </CDataTable>


                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {

        },
        data() {
            return {
              VUE_APP_Currency:localStorage.getItem('currency'),

              show_document: 'test-dynamic',
                printed_doc_id:0,
                name: '',
                file: '',
                color: '#ffffff',
                start_date: '',
                end_date: '',
                previewImage: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                description: null,
                id_checkbox_items: [],
                item_sell_array:[],
user_all_porsant:'',
                items_sell: items_data.map((item, row_id) => {

                    return {...item, row_id}

                }),
                fields : [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:2%'},
                    {key: 'createdAt', label:this.$t('tables.date'), _style: 'width:15%'},
                    {key: 'masterId', label: this.$t('tables.number'), _style: 'width:2%'},
                    // {key: 'انبار', _style: 'width:10%'},
                    // {key: 'مبلغ', _style: 'width:10%'},
                    {key: 'customer', label: this.$t('tables.customer'), _style: 'width:20%'},
                    {key: 'user', label: this.$t('tables.user'), _style: 'width:15%'},
                    {key: 'soodFactorFromProuct', label: this.$t('tables.commission'), _style: 'width:15%'},
                    {key: 'userPorsant',  label: this.$t('tables.userCommission'), _style: 'width:15%'},

                    {key: 'operation',label: this.$t('tables.operation'), _style: 'width:20%;'},


                ],

                details: [],
                templates_items: [
                    {template_id: 'One', name: 'A'},
                    {template_id: 'Two', name: 'B'},
                    {template_id: 'Three', name: 'C'}
                ],
                collapseDuration: 0,
                status_form: 0,

            }
        }, mounted() {

            this.start_date =  moment().format('YYYY-MM-01');
            this.end_date =  this.get_today();

            this.$root.root_validate_errors = [];



            this.get_lists_sell();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {

            'start_date': function () {

                this.get_lists_sell();

            },
            'end_date': function () {

                this.get_lists_sell();

            }
        },
        methods: {
            get_all_porsant() {
                var total_user_porsant = 0;

                this.items_sell.forEach((val)=>{
                    total_user_porsant +=parseInt(val.userPorsant);
                });
               this.user_all_porsant =  total_user_porsant.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.row_id].unitName;
                this.color = this.items[item.row_id].color;
                this.description = this.items[item.row_id].description;
                this.previewImage = this.items[item.row_id].image;
                this.status_form = this.items[item.row_id].id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },

            get_lists_sell() {

                var self = this;


                const formData = new FormData();

                var url = "GetPersonPorsantsByPersonId";
                        formData.append("PersonId", self.$route.params.person_id);



                // formData.append("id", 3);

                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {

                            self.items_sell = content_data.data.map((item, row_id) => {
                                return {...item, row_id}

                            });

                        self.get_all_porsant();
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });



            },

            goShowDocument(item, index) {

                this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },


            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"),this.$t("dialogs.deleteMessage") , [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = this.items[item.row_id].id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                  self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {



                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;
                        // self.color = '';
                        // self.description = '';
                        // self.previewImage = '';
                        // self.get_lists();

                      self.$root.modal_component.show_api_response_modals(res);

                      self.get_lists_sell();

                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {
                            //



                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;
                    // self.color = '';
                    // self.description = '';
                    // self.previewImage = '';
                    // self.get_lists();

                    //this.$root.modal_component.show_api_response_modals(res);

                    this.get_lists_buy();
                    this.get_lists_buy_return();
                    this.get_lists_sell(1);
                    this.get_lists_sell_return();
                    this.get_lists_first();
                    this.get_lists_first_return();
                }


            },

        },

    }

</script>
